
import React, { useEffect, useState } from 'react'
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { Modal, Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import CustomInput from '../../common/CustomInput';
import SelectInput from '../../common/SelectInput';
import { useDispatch, useSelector } from "react-redux";
import ImagesInput from '../../common/ImagesInput';
import { object, string, mixed } from "yup"
import { PostSlider, UpdateSlider } from '../../../redux/actions/SettingActions';
import { toast } from 'react-toastify';

const ModalSlider = ({ openModal, onCloseModal, data }) => {
	const dispatch = useDispatch();
	const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
	const [image, setImage] = useState(null)
	const [loading, setLoading] = useState(false)
	const schema = object().shape({
		image: image && yup.mixed()
			.required("Image is required", (file) => {
				// return file && file.size <-- u can use this if you don't want to allow empty files to be uploaded;
				if (file) return true;
				return false;
			})
			.test("fileSize", "The file is too large", (file) => {
				//if u want to allow only certain file sizes
				return file && file.size <= 2000000;
			}),
		order: yup.string().required("Order  is Required"),
		type: yup.mixed()
			.required("Type is Required")
			.test("isValidType", "Type must be either 'web' or 'mobile'", (value) => {
				if (!value) return false;
				const stringValue = typeof value === 'object' && value !== null ? value.value : value;
				return stringValue === 'web' || stringValue === 'mobile';
			})
			.transform((value) => {
				if (typeof value === 'object' && value !== null && value.value) {
					return value.value;
				}
				return value;
			})
	}).required()



	const { sliderlistcreated } = useSelector(state => state.settings)


	const typeOptions = [
		{ value: 'web', label: 'Web' },
		{ value: 'mobile', label: 'Mobile' }
	];

	const { register, handleSubmit, setFieldValue, control, formState: { errors }, reset, setValue, watch } = useForm({
		resolver: yupResolver(schema),
		defaultValues: {
			image: null,
			name: '',
			order: '',
			type: null
		}
	});

	// Watch the type field to determine image resolution
	const watchedType = watch('type');
	const typeValue = typeof watchedType === 'object' && watchedType !== null ? watchedType.value : watchedType;
	const isMobile = typeValue === 'mobile';
	const imageWidth = isMobile ? 415 : 1920;
	const imageHeight = 730;




	useEffect(() => {
		if (sliderlistcreated) {
			reset()
			setImage(null)
		}

		return () => {
			reset()
			setImage(null)
		}
	}, [sliderlistcreated])



	const submitform = (datas) => {

		setLoading(true)

		// Extract type value if it's an object from react-select
		const typeValue = typeof datas?.type === 'object' && datas?.type !== null ? datas?.type.value : datas?.type;

		if (data) {
			const formData = new FormData();
			formData.append('id', data?._id);
			formData.append('status', data?.status);
			formData.append('name', datas?.name === "" ? data?.name : datas?.name);
			formData.append('order', datas?.order === "" ? data?.order : datas?.order);
			formData.append('type', typeValue || data?.type || 'web');
			if (datas?.image) {
				formData.append('image', datas?.image);
			}
			dispatch(UpdateSlider(formData)).finally(() => setLoading(false));

		} else {

			if (!image) {
				toast.warn('Image is Required');
				return false;
			}
			const formData = new FormData();
			formData.append('name', datas?.name);
			formData.append('order', datas?.order);
			formData.append('type', typeValue || 'web');
			formData.append('image', datas?.image);
			dispatch(PostSlider(formData)).finally(() => setLoading(false));
		}


	}

	useEffect(() => {
		if (data) {
			setValue("name", data?.name)
			setValue("order", data?.order)
			// Set type as react-select object if it exists
			if (data?.type) {
				const typeOption = typeOptions.find(opt => opt.value === data.type);
				setValue("type", typeOption || { value: data.type, label: data.type.charAt(0).toUpperCase() + data.type.slice(1) });
			}
			// setValue("image", data?.image)
		}
	}, [data])
	const cleardata = () => {
		reset()
		setImage(null)
		onCloseModal()

	}

	const onImgLoad = ({ target: img }) => {
		// Get current type value
		const currentType = typeof watchedType === 'object' && watchedType !== null ? watchedType.value : watchedType;
		// Default to web resolution if type is not selected
		const expectedWidth = currentType === 'mobile' ? 415 : 1920;
		const expectedHeight = 730;

		if (img.offsetWidth === expectedWidth && img.offsetHeight === expectedHeight) {
			setValue("image", image)
		}
		else {
			setValue("image", null)
			toast.error(`Image resolution should be ${expectedWidth}px * ${expectedHeight}px`);
		}
	}



	return (
		<Modal isOpen={openModal} toggle={cleardata}>
			<ModalHeader toggle={cleardata}>
				<h5
					className="modal-title f-w-600"
					id="exampleModalLabel2"
				>
					{data ? 'Edit Slider' : 'Add Slider'}
				</h5>
			</ModalHeader>
			<ModalBody>
				<Form>
					<CustomInput
						fieldLabel='Slider Name :'
						control={control}
						error={errors.name}
						fieldName='name'
					/>
					<CustomInput
						fieldLabel='Order :'
						control={control}
						error={errors.order}
						fieldName='order'
						type={"number"}
					// disabled={data ? da : false}
					/>
					<SelectInput
						fieldLabel='Type :'
						control={control}
						error={errors.type}
						fieldName='type'
						options={typeOptions}
					/>
					{/* <span style={{ color: "red" }}>Image resolution should be 768px * 1000px</span> */}
					<div><img src={data?.image} style={{ width: "100px", width: "100px" }}></img></div>
					<ImagesInput
						//fieldLabel='Image (1920px * 810px) :'
						fieldLabel={`Image (${imageWidth}px * ${imageHeight}px) :`}
						control={control}
						error={errors.image}
						fieldName='image'
						type='file'
						onChangeValue={(file) => setImage(file)}
					/>


				</Form>
			</ModalBody>
			<ModalFooter>
				<Button
					type="button"
					color="primary"
					disabled={loading ? true : false}
					onClick={handleSubmit(submitform)}
				>
					{loading ? "Saving" : "Save"}
				</Button>
				{/* <Button
					type="button"
					color="secondary"
					onClick={() => onCloseModal(
					)}
				>
					Close
				</Button> */}
			</ModalFooter>
			{image && <div style={{ height: 1, opacity: 0 }} ><img onLoad={onImgLoad} src={URL.createObjectURL(image)} /></div>}
		</Modal>
	)
}

export default ModalSlider